// extracted by mini-css-extract-plugin
module.exports = {"longIcon":"icons_longIcon__1KloW"};